export const ES_TRANSLATE = {
    "HELLO": "Hola",
    "back": "Atrás",
    "ok": "Ok",
    "cancel": "Cancelar",
    "startBtn": "Comenzar",

    "detox": "Desintoxicación",
    "detoxPlan": "Menús y Recetas",
    "settings": "Configuraciones",
    "shoppingList": "Lista de compras",
    "termsOfUse": "Términos de uso",
    "guides": "Guías",
    "aboutUs": "Acerca de nosotros",
    "slogan": "21 días de limpieza corporal saludable",

    "dailyMenu": "Menú diario",
    "day": "Día",
    "finish": "Qué hacer ahora",
    "ingredients": "Ingredientes",
    "instructions": "Instrucciones",
    "intro": "Introducción",
    "markThisDay": "Marcar este día como hecho",
    "serving": "Porción",
    "servings": "Porciones",
    "meals": [
        {
            "name": "Desayuno"
        },
        {
            "name": "Media mañana"
        },
        {
            "name": "Almuerzo"
        },
        {
            "name": "Merienda"
        },
        {
            "name": "Cena"
        }
    ],

    "more": "más",
    "language": "Idioma",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "Unidad",
    "selectDetoxPlan": "Seleccione su plan de desintoxicación",
    "detoxPlans": "Planes de desintoxicación",
    "restart": "Reiniciar",
    "start": "Comenzar",
    "days": "días",
    "standard": "estándar",
    "vegan": "vegano",
    "vegetarian": "vegetariano",
    "pescetarian": "pescetariano",
    "wellDone": "¡Bien hecho!",
    "whatsNow": "Qué hacer ahora",

    "youDidIt": "Bien hecho, lo hiciste",
    "weProud": "Estamos orgullosos de ti,",
    "presentYourself": "Te has dado un regalo increíble",

    "messages": {
        "resetApp": {
            "title": "Reiniciar la aplicación",
            "content": "Esta acción reiniciará la lista de compras y los días marcados como hechos.\nPresione OK si desea reiniciar la aplicación."
        }
    },
}
